import React from 'react';
import { HStack, Button, VStack } from '@chakra-ui/react';
import { useTokens } from '../../../../context/TokenProvider';
import BinButton from './BinButton';
import { localise } from '../../../../services/lang/lang';
import PlusIcon from '../../../icons/PlusIcon/PlusIcon';
import useEditFindingMultiSelect from './useEditFindingMultiSelect';
import CustomSelect from '../../CustomSelect/CustomSelect';
const EditFindingMultiSelect = ({ selectedOptions, allAvailableOptions, setSelected, nameField, isDisabled, }) => {
    const tokens = useTokens();
    const { multiSelectOptions, onAdd, onSelected, onRemove } = useEditFindingMultiSelect({
        allAvailableOptions,
        selectedOptions,
        setSelected,
    });
    const dropdowns = multiSelectOptions.map((option, index) => (React.createElement(HStack, { w: "100%", key: index, spacing: tokens.Spacing04 },
        React.createElement(CustomSelect, { groups: [
                {
                    options: option.availableForThisField,
                },
            ], value: option.selectedOption.id, nameField: nameField, onChange: (value) => onSelected(option.selectedOption.id, Number(value)), isDisabled: isDisabled, "aria-label": localise('SELECT_OPTION') }),
        React.createElement(BinButton, { isDisabled: isDisabled, "aria-label": localise('REMOVE'), onClick: () => onRemove(option.selectedOption) }))));
    return (React.createElement(VStack, { align: "start", spacing: tokens.Spacing05 },
        dropdowns,
        React.createElement(Button, { isDisabled: isDisabled, onClick: onAdd, variant: "secondary", leftIcon: React.createElement(PlusIcon, null) }, localise('ADD'))));
};
export default EditFindingMultiSelect;
